<template>
  <qx-card :title="this.$route.path.includes('gasCard')?'气消费记录':'油消费记录'">
    <section slot="titleLeft">
      【{{this.$route.path.includes('gasCard')?'加气方数':'加油升数'}}：
      <span class="primary">{{ totalData.oilRise / 1000 }}</span>
      】 【总金额：
      <span class="primary">{{ totalData.amount / 100 }}</span>
      】 【返利金额：
      <span class="primary">{{ totalData.fleetRebateAmount / 100 }}</span>
      】
    </section>
    <section slot="titleRight">
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050302':'1005030300'">
        <ImportBtn
          title="消费记录导入"
          fileUrl="/file/油卡消费记录导入模板.xlsx"
          btnName="消费记录导入"
          :isDownloadLocalTemplate="true"
          bizCodes="imp1000131"
          type="getImportTempFile"
          v-if="!this.$route.path.includes('gasCard')"
        />
        <ImportBtn
            title="消费记录导入"
            fileUrl="/file/气卡消费记录导入模板.xlsx"
            btnName="消费记录导入"
            :isDownloadLocalTemplate="true"
            bizCodes="imp1000132"
            type="getImportTempFile"
            v-if="this.$route.path.includes('gasCard')"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1005030301">
        <ImportBtn
          title="中石化记录导入"
          fileUrl="/file/中石化记录导入模板.xlsx"
          btnName="中石化记录导入"
          :isDownloadLocalTemplate="true"
          bizCodes="imp100030"
          type="getImportTempFile"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1005030302">
        <ImportBtn
          title="中石油记录导入"
          :isDownloadLocalTemplate="true"
          bizCodes="imp100040"
          type="getImportTempFile"
          fileUrl="/file/中石油消费记录导入模板.xlsx"
          btnName="中石油记录导入"
        />
      </qx-permpisions>
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050301':'1005030303'">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="voucherInfoBO.ajax?cmd=getOilConsumeRecords"
          :params="fullSearchData"
          :bizName="this.$route.path.includes('gasCard')?'气卡消费记录导出':'油卡消费记录导出'"
          bizCode="exp100036"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <QrcodeDialog ref="qrcodeDialog" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'plateNumber'">
                  <el-tooltip
                    :content="scope.row[scope.column.property]"
                    v-if="scope.row.plateNumber"
                  >
                    <span class="primary cur">{{
                      scope.row.plateNumber.substr(0, 7)
                    }}</span>
                  </el-tooltip>
                  <span v-if="!scope.row.plateNumber">--</span>
                </section>
<!--                <section v-else-if="scope.column.property==='oilCardTypeName'">-->
<!--                  <span v-if="scope.row.oilCardType===6 && scope.row.cardTypeRemark">{{scope.row.cardTypeRemark}}</span>-->
<!--                  <span v-else>{{scope.row.oilCardTypeName}}</span>-->
<!--                </section>-->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  oilConsumeList, // 消费列表
  oilConsumeTotal, // 数值总览
} from 'api/service';
import QrcodeDialog from 'components/qrcodeDialog';
import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    QrcodeDialog,
    ExportBtn,
    ImportBtn,
    TableSetting,
  },
  data () {
    return {
      totalData: {
        amount: 0, // 总金额
        fleetRebateAmount: 0, // 返利金额
        oilRise: 0, // 加油升数
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'cardNum', label: '卡号', fixed: true },
          { prop: 'consumeDate', label: '消费时间' },
          { prop: 'sourceTypeName', label: '来源类型' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'cardHolder', label: '司机' },
          { prop: 'oilRiseDouble', label: '加油量（升）' },
          { prop: 'unitPriceDouble', label: '单价（元）' },
          { prop: 'amountDouble', label: '金额' },
          { prop: 'cardTypeName', label: '卡类型' },
          // { prop: 'productName', label: '油站名称' },
          // { prop: 'oilStationTypeName', label: '油站类型' },
          { prop: 'consuemStation', label: '消费地点' },
          { prop: 'isExpire', label: '到期状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilConsumeList,
    async getOtherMsg (params) {
      const res = await oilConsumeTotal(params);
      if (!res.failed) {
        this.totalData = res.items[0] || {
          amount: 0, // 总金额
          fleetRebateAmount: 0, // 返利金额
          oilRise: 0, // 加油升数
        };
      }
    },
    toTrans (item) {
      console.log('去交易列表');
    },
    showQrCode (item) {
      this.$refs.qrcodeDialog.show('陈皮');
    },
  },
  created () {
    if (this.$route.path.includes('gasCard')) {
      let Index;
      this.tableData.title.forEach((item, index) => {
        if (item.label.includes('加油量（升）')) {
          item.label = item.label.replace(/加油量（升）/g, '加气量（立方米）');
        }
        if (item.prop === 'cardTypeName') {
          Index = index;
        }
      });
      this.tableData.title.splice(Index + 1, 0, { prop: 'cardTypeRemark', label: '类型备注' },);
    }

  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
